import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`${_ctx.width} ${_ctx.height} ${_ctx.outerRingThickness} ${_ctx.innerRingThickness}`, "small-loader ease-linear rounded-full border-gray-200 mb-4 border-b-primary"])
  }, null, 2))
}